
<template>
	<transition name="promotion-banner">
		<div class="promotion-banner" v-if="open">
			<div class="container">
				<p class="content">{{ content }}</p>
				<button class="close" @click="$emit('close')">
					<i class="fal fa-times" />
				</button>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	name: "PromotionBannder",
	props: {
		open: {
			type: Boolean,
			required: true
		},
		content: {
			type: String,
			required: true
		}
	}
};
</script>

<style lang="scss" scoped>
.promotion-banner {
	background-color: $teal;
	color: white;
	padding-top: 8px;
	padding-bottom: 8px;

	&-enter-active,
	&-leave-active {
		transition: max-height 0.2s ease-out;
	}

	&-enter,
	&-leave-to {
		overflow: hidden;
		max-height: 0;
	}
}

.container {
	@include outer-container();
	position: relative;
	text-align: center;
}

.content {
	margin: 0;
	font-size: 12px;
}

.close {
	@include button-reset();
	position: absolute;
	top: 50%;
	right: 16px;
	transform: translateY(-50%);
}
</style>